class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);


/*
// Upsell Karussell
document.addEventListener("DOMContentLoaded", function () {
    console.log("Seite vollständig geladen!");

    function loadUpsellProducts(cartHasItems) {
        console.log("Lade Upsell-Produkte...");

        const upsellBlockContainer = document.querySelector(".custom-upsell-block-pegas");
        if (!cartHasItems) {
            if (upsellBlockContainer) upsellBlockContainer.style.display = "none";
            console.log("🛑 Warenkorb ist leer. Upsell-Karussell wird ausgeblendet.");
            return;
        } else {
            if (upsellBlockContainer) upsellBlockContainer.style.display = "block";
        }

        fetch('/collections/upsell-products/products.json')
            .then(response => response.json())
            .then(data => {
                if (!data || !data.products || data.products.length === 0) {
                    console.error("❌ Keine Produkte gefunden!");
                    return;
                }

                let products = data.products;
                let upsellHTML = '';

                products.forEach(product => {
                    let price = (product.variants[0].price / 1);
                    let comparePrice = product.variants[0].compare_at_price
                        ? (product.variants[0].compare_at_price / 1)
                        : null;

                    let priceHTML = `<p class="cart-upsell-price">€${price}</p>`;

                    if (comparePrice && comparePrice > price) {
                        priceHTML =
                            `<p class="cart-upsell-price">
                                <s class="cart-upsell-compare-price">€${comparePrice}</s> 
                                <span class="discount-price">€${price}</span>
                            </p>`;
                    }

                    upsellHTML +=
                        `<div class="cart-upsell-item">
                            <img src="${product.images[0].src}" alt="${product.title}">
                            <div class="cart-upsell-text">
                                <p class="cart-upsell-name">${product.title}</p>
                                ${priceHTML}
                            </div>
                            <div class="cart-upsell-form">
                                <a href="/products/${product.handle}" class="cart-upsell-add" style="text-decoration: none; background-color: #000; color: #fff; padding: 10px 20px; margin-right:10px ; display: inline-block; text-align: center; border-radius: 4px;">
                                    Erfahre mehr
                                </a>
                            </div>
                        </div>`;
                });

                insertUpsellCarousel(upsellHTML);
            })
            .catch(error => {
                console.error("❌ Fehler beim Abrufen der Produkte:", error);
            });
    }

    function insertUpsellCarousel(upsellHTML) {
        console.log("Versuche, den Upsell-Container zu erstellen...");

        const upsellBlockContainer = document.querySelector(".custom-upsell-block-pegas");
        if (!upsellBlockContainer) {
            console.error("❌ Container 'custom-upsell-block-pegas' nicht gefunden!");
            return;
        }

        let upsellContainer = document.querySelector(".cart-upsell-container");
        if (upsellContainer) {
            upsellContainer.remove();
        }

        upsellContainer = document.createElement("div");
        upsellContainer.classList.add("cart-upsell-container");
        upsellContainer.innerHTML = `
            <div class="cart-upsell-header">
                <div class="cart-upsell-title">Passend dazu</div>
                <div class="cart-upsell-nav">
                    <button class="cart-upsell-prev">‹</button>
                    <button class="cart-upsell-next">›</button>
                </div>
            </div>
            <div class="cart-upsell-items"></div>
        `;

        upsellBlockContainer.appendChild(upsellContainer);
        upsellContainer.querySelector(".cart-upsell-items").innerHTML = upsellHTML;
        setupCarousel();
    }

    function setupCarousel() {
        console.log("Setup Karussell...");

        const prevButton = document.querySelector(".cart-upsell-prev");
        const nextButton = document.querySelector(".cart-upsell-next");
        if (!prevButton || !nextButton) {
            console.error("❌ Upsell-Elemente nicht gefunden!");
            return;
        }

        function getScrollAmount() {
            const item = document.querySelector(".cart-upsell-item");
            return item ? item.offsetWidth + 10 : 300;
        }

        function updateButtons() {
            const upsellContainer = document.querySelector(".cart-upsell-items");
            if (!upsellContainer) return;
            prevButton.disabled = upsellContainer.scrollLeft <= 0;
            nextButton.disabled = upsellContainer.scrollLeft + upsellContainer.clientWidth >= upsellContainer.scrollWidth - 1;
        }

        nextButton.addEventListener("click", function () {
            const upsellContainer = document.querySelector(".cart-upsell-items");
            upsellContainer.scrollBy({ left: getScrollAmount(), behavior: "smooth" });
            setTimeout(updateButtons, 300);
        });

        prevButton.addEventListener("click", function () {
            const upsellContainer = document.querySelector(".cart-upsell-items");
            upsellContainer.scrollBy({ left: -getScrollAmount(), behavior: "smooth" });
            setTimeout(updateButtons, 300);
        });

        document.querySelector(".cart-upsell-items").addEventListener("scroll", updateButtons);
        updateButtons();
    }

    function monitorUpsellContainer() {
        setInterval(() => {
            const upsellBlockContainer = document.querySelector(".custom-upsell-block-pegas");
            const upsellContainer = document.querySelector(".cart-upsell-container");

            if (upsellBlockContainer && !upsellContainer) {
                console.log("Upsell-Container wurde entfernt, erneut einfügen...");
                checkCartStatus();
            }
        }, 1000);
    }

    function checkCartStatus() {
        fetch('/cart.js')
            .then(response => response.json())
            .then(cart => {
                let cartHasItems = cart.item_count > 0;
                loadUpsellProducts(cartHasItems);
            })
            .catch(() => {
                console.error("Fehler beim Abrufen des Warenkorbs.");
            });
    }

    document.addEventListener("cart:updated", checkCartStatus);
    document.addEventListener("change", function () {
        console.log("Änderung im Warenkorb erkannt. Upsell-Produkte werden aktualisiert.");
        checkCartStatus();
    });

    setTimeout(checkCartStatus, 500);
    monitorUpsellContainer();
});

*/

//progress bar custo


/*
document.addEventListener("DOMContentLoaded", function () {
    function updateCartDrawerShippingProgress() {
        fetch('/cart.js')
            .then(response => response.json())
            .then(data => {
                let cartTotal = data.total_price / 100; // Shopify gibt Preis in Cent zurück
                let freeShippingThreshold = 50; // Kostenloser Versand ab 50€

                let remainingAmount = Math.max(0, freeShippingThreshold - cartTotal);

                let messageElement = document.querySelector("#cart-drawer-shipping-message");
                let progressBar = document.querySelector(".cart-drawer-shipping-progress-fill");
                let progressBarContainer = document.querySelector(".cart-drawer-shipping-progress-bar");

                if (!messageElement || !progressBar || !progressBarContainer) {
                    setTimeout(updateCartDrawerShippingProgress, 500);
                    return;
                }

                // Fortschrittsleiste einblenden
                progressBarContainer.style.display = "block";

                if (remainingAmount > 0) {
                    messageElement.innerHTML = `Nur noch <strong>€${remainingAmount.toFixed(2)}</strong> bis zum kostenlosen Versand!`;
                } else {
                    messageElement.innerHTML = `<strong>Glückwunsch! Kostenloser Versand aktiviert.</strong>`;
                }

                let progress = Math.min(100, (cartTotal / freeShippingThreshold) * 100);
                progressBar.style.width = progress + "%";

            })
            .catch(() => {});
    }

    // 🛒 **Warenkorb öffnen: Fortschrittsleiste aktualisieren**
    document.addEventListener("cart:open", function () {
        setTimeout(updateCartDrawerShippingProgress, 700);
    });

    // **Sicherstellen, dass das Update auch nach Änderungen ausgeführt wird**
    document.addEventListener("cart:updated", updateCartDrawerShippingProgress);

    document.addEventListener("click", function(event) {
        if (event.target.closest(".cart__remove") || event.target.closest(".quantity__button")) {
            setTimeout(updateCartDrawerShippingProgress, 700);
        }
    });

    // **Fix für das Hinzufügen eines Artikels in den Warenkorb**
    document.addEventListener("click", function(event) {
        let addToCartButton = event.target.closest("form[action*='/cart/add']");
        if (addToCartButton) {
            event.preventDefault();
            let formData = new FormData(addToCartButton);
            fetch('/cart/add.js', {
                method: 'POST',
                body: formData
            })
            .then(response => response.json())
            .then(data => {
                document.dispatchEvent(new CustomEvent('cart:updated'));
                setTimeout(() => {
                    document.dispatchEvent(new CustomEvent('cart:open'));
                    updateCartDrawerShippingProgress();
                }, 700);
            })
            .catch(() => {});
        }
    });

    // **Initiales Update nach Laden der Seite**
    setTimeout(updateCartDrawerShippingProgress, 500);
});


document.addEventListener("DOMContentLoaded", function () {
    function openCartDrawer() {
        let cartDrawer = document.querySelector("cart-drawer");
        if (cartDrawer) {
            cartDrawer.open(); // Shopify's Dawn Theme Drawer öffnen
        } else {
            document.dispatchEvent(new CustomEvent("cart:open"));
        }

        // Neuladen des Warenkorbs nach kurzer Verzögerung
        setTimeout(() => {
            fetch('/cart.js') // Abrufen der aktuellen Warenkorb-Daten
                .then(response => response.json())
                .then(cart => {
                    document.dispatchEvent(new CustomEvent("cart:updated", { detail: cart }));
                });
        }, 500);
    }

    // Event für den Desktop Warenkorb Button
    const cartButtonDesktop = document.getElementById("open-cart-drawer-desktop");
    if (cartButtonDesktop) {
        cartButtonDesktop.addEventListener("click", openCartDrawer);
    }

    // Event für den Mobile Warenkorb Button
    const cartButtonMobile = document.getElementById("open-cart-drawer-mobile");
    if (cartButtonMobile) {
        cartButtonMobile.addEventListener("click", openCartDrawer);
    }

    // Event für "In den Warenkorb"-Buttons
    const addToCartButtons = document.querySelectorAll('form[action*="/cart/add"] button');
    addToCartButtons.forEach(button => {
        button.addEventListener("click", function () {
            setTimeout(openCartDrawer, 500); // Drawer nach einer Sekunde erneut öffnen und aktualisieren
        });
    });

    // Event-Listener zum Neuladen des Warenkorbs nach Updates
  
});
*/
